import React from "react";

interface LomavisH2Props {
    /** The text to display inside the H2 heading */
    title: string;
    /** Optional additional CSS class names */
    className?: string;
}

/**
 * Atom: LomavisH2
 *
 * A bold section heading with bottom margin.
 * Used for titles and section headers throughout the UI.
 */
export const LomavisH2: React.FC<LomavisH2Props> = ({ title, className = "" }) => {
    return <h2 className={`fs-2 fw-bolder ${className}`.trim()}>{title}</h2>;
};
